import * as types from 'Redux/types/enterprise';
import { request, requestOptions } from 'Helpers/Graphql';
import { trackEvent } from 'Helpers/Tracking';
import yup from 'yup';

import enterpriseMissionsContactRequest from 'Gql/mutations/enterprise.missionsContactRequest.mutation';
import contactSalesContactRequest from 'Gql/mutations/enterprise.salesContactRequest.mutation';
import validationErrorFragment from 'Gql/fragments/validationError';

export const missionContactRequest = (data) => (dispatch) => {
    return request(types.MISSION_REQUEST, enterpriseMissionsContactRequest, data, missionContactRequest).then(response => {
        trackEvent('enterpriseContact', { source: 'mission' });

        return response;
    });
};

export const salesContactRequest = (data) => (dispatch) => {
    return request(types.SALES_REQUEST, contactSalesContactRequest, data, salesContactRequest).then(response => {
        trackEvent('enterpriseContact', { source: 'sales' });

        return response;
    });
};

export const sendMissionEstimation = (params = {}, req) => (dispatch) => {
    params = {
        ...params,
    };

    return requestOptions({
        req: req,
        type: types.MISSION_ESTIMATION,
        onRetry: sendMissionEstimation,
        name: 'requestProjectEstimation',
        validationSchema: yup.object().shape({
            data: yup.object().shape({
                estimation: yup.object().shape({
                    success: yup.boolean()
                }).required()
            }).required()
        }),
        params: params,
        requestParams: params,
        query: `
            mutation requestProjectEstimation (
                $firstName: String!
                $lastName: String!
                $companyName: String!
                $phoneNumber: String!
                $phoneCode: String!
                $message: String!
                $email: String!
                $policyAcknowledgement: Boolean!
                $subscriptionAcknowledgement: Boolean!
            ) { 
                estimation: requestProjectEstimation ( 
                    input: {
                        firstName: $firstName
                        lastName: $lastName
                        companyName: $companyName
                        phoneNumber: $phoneNumber
                        phoneCode: $phoneCode
                        message: $message
                        email: $email
                        policyAcknowledgement: $policyAcknowledgement
                        subscriptionAcknowledgement: $subscriptionAcknowledgement
                    }
                ) { 
                    errors {
                        ...validationError
                    }
                    success
                } 
            }
        ${validationErrorFragment}`
    });
};




// WEBPACK FOOTER //
// ./src/redux/actions/enterprise.js